import Button from 'Components/Atoms/ButtonDeprecated/Button';
import DotBtnItem from 'Components/Atoms/DotBtnItem/DotBtnItem';
import EditButtons from 'Components/Atoms/EditButtons/EditButtons';
import { Arrow } from 'Components/Atoms/ExpandableItems/Arrow';
import TextItem from 'Components/Atoms/ExpandableItems/TextItem';
import TextItemInfo from 'Components/Atoms/ExpandableItems/TextItemInfo';
import TextItemLabel from 'Components/Atoms/ExpandableItems/TextItemLabel';
import RowItem from 'Components/Atoms/Row/RowItem';
import RowItemInfo from 'Components/Atoms/Row/RowItemInfo';
import RowItemTitle from 'Components/Atoms/Row/RowItemTitle';
import Text from 'Components/Atoms/Text/Text';
import { useEffect, useState } from 'react';
import DualListBox from 'react-dual-listbox';
import 'react-dual-listbox/lib/react-dual-listbox.css';
import { connect } from 'react-redux';
import { deleteField, editField, fetchAllCategories, resetFields, restoreField, saveFields } from 'Store/FieldManagement/Actions';
import { FieldStatus, FieldType, getFieldTypeLabel } from 'Store/FieldManagement/PropTypes';
import { getAllDatasets, getAllFields, getFieldById } from 'Store/FieldManagement/Selectors';
import styles from './EntityField.module.sass';
import Field from './FieldTypes/Field';
import EditorRedoIcon from '@atlaskit/icon/glyph/editor/redo';
import NoValue from 'Components/Atoms/NoValue/NoValue';
import { prepareDualListBox } from 'Services/helpers';

const EntityField = (props: any) => {
    const [isEditable, setEditable] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [isOpen, setOpen] = useState(false);

    const sendToStore = (data: any) => {
        props.editField({
            entity: props.entity,
            id: props.id
        }, data);
    }

    const handleDelete = () => {
        setLoading(true);
        props.deleteField(props.id).then(() => 
            props.fetchAllCategories().then(() =>
                setLoading(false)
            )
        );
    };

    const handleSave = () => props.saveFields(props.fields[props.entity].unsaved);

    const handleCancel = () => {
        props.resetFields(props.entity);
    }

    useEffect(() => {
        if (isEditable && !isOpen) {
            setOpen(true);
        }
    }, [isEditable]);

    const [copiedId, setCopiedId] = useState<any>(false);
    useEffect(() => {
        navigator.clipboard.writeText(props.field?.id);

        if (copiedId) {
            setTimeout(() => {
                setCopiedId(false);
            }, 400);
        }
    }, [copiedId]);

    return <div className={`expandable manage ${isOpen ? 'open' : ''}`} style={{'opacity': props.status === FieldStatus.Inactive ? .6 : 1}}>
        <div className={'expandable-item'}>
            <div className={'expandable-item__arrow'} onClick={() => setOpen(!isOpen)}>
                <Arrow />
            </div>
            <div className={'expandable-item__wrapper'}>
                <div className={'expandable-item__name'}>
                    <Text>
                        <Field
                            isEdit={false}
                            value={props.field?.name}
                            type={FieldType.Text}
                        />
                    </Text>
                </div>
                <TextItem hasBorder>
                    <TextItemLabel>Type:</TextItemLabel>
                    <TextItemInfo>{getFieldTypeLabel(props.type)}</TextItemInfo>
                </TextItem>
                <TextItem>
                    <TextItemLabel>Openbaar:</TextItemLabel>
                    <TextItemInfo>
                        { props.field?.is_public ? 'Ja' : 'Nee' }
                    </TextItemInfo>
                </TextItem>
                <TextItem>
                    <TextItemLabel>Verplicht:</TextItemLabel>
                    <TextItemInfo>
                        <Field
                            isEdit={false}
                            value={props.field?.required}
                            type={FieldType.Toggle}
                        />
                    </TextItemInfo>
                </TextItem>

                <div className={'expandable-item__toolbox'}>
                    { props.status === FieldStatus.Inactive && <Button
                        style={{borderRadius: '100%'}}
                        appearance="subtle"
                        iconBefore={<EditorRedoIcon primaryColor={'#97969E'} label="edit" size="medium"/>}
                        onClick={() => props.restoreField(props.id)}
                    /> }
                    {
                        props.status === FieldStatus.Active && <EditButtons
                            onEdit={(value) => setEditable(value)}
                            onSave={handleSave}
                            onCancel={handleCancel}
                            onDelete={handleDelete}
                            onDeleteOpen={() => {}}
                            isLoading={isLoading}
                            deleteDescription={'Het veld zal niet meer zichtbaar zijn.'}
                            isDropdown
                        >
                            <DotBtnItem name={copiedId ? 'Gekopieerd!' : 'Kopieer ID'} onClick={() => setCopiedId(true)} />
                        </EditButtons>
                    }
                </div>
            </div>
        </div>
        {
            isOpen &&
            <div className={styles['entityfield__detailed']}>
                <RowItem>
                    <RowItemTitle>Titel</RowItemTitle>
                    <RowItemInfo>
                        <Field
                            isEdit={isEditable}
                            value={props.field?.name}
                            type={FieldType.Text}
                            required={false}
                            onChange={(value: any) => {
                                if (value.length <= 25) {
                                    sendToStore({name: value})
                                }
                            }}
                        />
                    </RowItemInfo>
                </RowItem>
                <RowItem>
                    <RowItemTitle>Type</RowItemTitle>
                    <RowItemInfo>
                        {
                            !isEditable
                            ? getFieldTypeLabel(props.type)
                            : !(props.type === FieldType.Dropdown || props.type === FieldType.Multi_Selector)
                            ? getFieldTypeLabel(props.type)
                            : <Field
                                isEdit={true}
                                type={FieldType.Select}
                                value={props.field.type}
                                onChange={(value: any) => sendToStore({type: value})}
                                fieldProperties={{
                                    list: [
                                        { label: getFieldTypeLabel(FieldType.Dropdown), value: FieldType.Dropdown, isDefault: true },
                                        { label: getFieldTypeLabel(FieldType.Multi_Selector), value: FieldType.Multi_Selector }
                                    ]
                                }}
                            />
                        }
                    </RowItemInfo>
                </RowItem>
                <RowItem>
                    <RowItemTitle>Openbaar</RowItemTitle>
                    <RowItemInfo>
                        <Field
                            isEdit={isEditable}
                            value={props.field?.is_public}
                            type={FieldType.Toggle}
                            onChange={(value: any) => sendToStore({is_public: value})}
                        />
                    </RowItemInfo>
                </RowItem>
                <RowItem>
                    <RowItemTitle>Verplicht</RowItemTitle>
                    <RowItemInfo>
                        <Field
                            isEdit={isEditable}
                            value={props.field?.required}
                            type={FieldType.Toggle}
                            onChange={(value: any) => sendToStore({required: value})}
                        />
                    </RowItemInfo>
                </RowItem>
                {
                    (props.type === FieldType.Dropdown || props.type === FieldType.Multi_Selector) && 
                    <RowItem>
                        <RowItemTitle>Default Waarde</RowItemTitle>
                        <RowItemInfo>
                            <Field
                                isEdit={isEditable}
                                value={props.field?.default?.value}
                                type={FieldType.Dropdown}
                                required={false}
                                onChange={(value: any) => sendToStore({default: {
                                    ...props.default,
                                    ...props.field?.default,
                                    value: value
                                }})}
                                fieldProperties={props.field?.default}
                                isInline
                            />
                        </RowItemInfo>
                    </RowItem>
                }
                {
                    (props.type === FieldType.Dropdown || props.type === FieldType.Multi_Selector) && 
                    <RowItem>
                        <RowItemTitle>Dataset</RowItemTitle>
                        <RowItemInfo>
                            <Field
                                isEdit={isEditable}
                                value={props.field?.default?.dataset}
                                type={FieldType.Dropdown}
                                required={false}
                                onChange={(value: any) => {
                                    const newValue = {
                                        ...props.default,
                                        ...props.field?.default,
                                        dataset: value
                                    };
                                    sendToStore({default: newValue});
                                }}
                                fieldProperties={{allowRoot: true, allowInternal: true, allowCustoms: true}}
                                isInline
                            />
                        </RowItemInfo>
                    </RowItem>
                }
                {
                    props.type === FieldType.Combination &&
                    <>
                        <RowItem>
                            <RowItemTitle>Meerdere waarden</RowItemTitle>
                            <RowItemInfo>
                                <Field
                                    isEdit={isEditable}
                                    value={!!props.field?.default?.multi}
                                    type={FieldType.Toggle}
                                    onChange={(value: any) => {
                                        const newValue = {
                                            ...props.field?.default,
                                            multi: value
                                        }
                                        sendToStore({default: newValue});
                                    }}
                                />
                            </RowItemInfo>
                        </RowItem>
                        <RowItem>
                            <RowItemTitle>Velden</RowItemTitle>
                            <RowItemInfo>
                                {
                                    !isEditable
                                    ? <Text>
                                        { !props.default?.fields
                                        ? <NoValue />
                                        : props.default?.fields.map((fieldId: any, index: number) => <>{(props.fields[props.entity]?.saved.find(({id}: any) => id === fieldId))?.name}<br/></>)}
                                    </Text>
                                    : <DualListBox
                                        preserveSelectOrder
                                        showOrderButtons
                                        options={prepareDualListBox(props.fields[props.entity]?.saved.filter((item: any) => item.type != FieldType.Combination && item.status != 0))}
                                        selected={props.field.default?.fields || []}
                                        onChange={(value: any) => sendToStore({default: {
                                            'entity': props.entity,
                                            'fields': value
                                        }})}
                                    />
                                }
                            </RowItemInfo>
                        </RowItem>
                    </>
                }
            </div>
        }
    </div>;
}

export default connect(
    (state: any, props: any) => ({
        fields: getAllFields(state),
        field: getFieldById(state, props.entity, props.id),
        
        datasets: getAllDatasets(state)
    }),
    {
        restoreField,
        deleteField,
        editField,
        saveFields,
        resetFields,
        fetchAllCategories
    }
)(EntityField);